import React from 'react'

const Heading = ({text}) => {
  return (
    <>
      <div id="icon-tools" className="icon32"></div>
      <h2 className="dreamfox-heading">Woocommerce Delivery Date Premium - {text}</h2>
    </>
  )
}

export default Heading
